import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.tipoActivo.fields.id'),
  },
  {
    name: 'descripcion',
    label: i18n('entities.tipoActivo.fields.descripcion'),
  },
  {
    name: 'habilitado',
    label: i18n('entities.tipoActivo.fields.habilitado'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'activosVinculados',
    label: i18n('entities.tipoActivo.fields.activosVinculados'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.tipoActivo.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.tipoActivo.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
